import { render } from "./UploadDocuments.vue?vue&type=template&id=5591fb98"
import script from "./UploadDocuments.vue?vue&type=script&lang=js"
export * from "./UploadDocuments.vue?vue&type=script&lang=js"

import "./UploadDocuments.vue?vue&type=style&index=0&id=5591fb98&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__